export const QUERY_KEYS = {
  redirectTo: 'redirect-to',
  ref: 'ref',
}
